// src/redux/slices/itemsSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getItems } from '../../firebase/itemsAndInventory/getItems';
import { ItemInfo } from '../../models/item';

export interface Item extends ItemInfo {
    key: string;
}

interface ItemsState {
    items: Item[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

const initialState: ItemsState = {
    items: [],
    status: 'idle',
    error: null,
};

export const fetchItems = createAsyncThunk('items/fetchItems', async () => {
    const itemsObject = await getItems();
    const itemsArray = Object.keys(itemsObject).map(key => ({
        ...itemsObject[key],
        key,
    }));
    return itemsArray;
});

const itemsSlice = createSlice({
    name: 'items',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchItems.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchItems.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.items = action.payload;
            })
            .addCase(fetchItems.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message || null;
            });
    },
});

export default itemsSlice.reducer;
